import { NgClass } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";

@Component({
    selector: "rask-arbetsorder-search-filter",
    templateUrl: "./arbetsorder-search-filter.component.html",
    styleUrls: ["./arbetsorder-search-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ButtonComponent,
        NgClass
    ]
})
export class ArbetsorderSearchFilterComponent {
  @Input() aid: string;
  @Input() title: string;
  @Input() visible = false;
  @Output() toggleVisibility: EventEmitter<any> = new EventEmitter<any>();
  @Input() hasValues = false;

  toggleShow() {
      this.toggleVisibility.emit();
  }

  getColor(): string {
      if (this.visible) {
          return "secondary";
      }
      if (this.hasValues) {
          return "primary";
      }
      return "tertiary";
  }

}
